import React from 'react'
import type { Props } from '../_utils/types'
import type { SplitViewCardInternalContextAPI } from './SplitViewCard.types'

export const SplitViewCardInternalContext =
  React.createContext<SplitViewCardInternalContextAPI>({
    ariaLabelledBy: undefined,
    isClosable: true,
    isScrolling: false,
    setIsScrolling: () => {},
  })

export const SplitViewCardInternalContextProvider = ({
  ariaLabelledBy,
  children,
  isClosable,
}: React.PropsWithChildren<
  Props & Pick<SplitViewCardInternalContextAPI, 'ariaLabelledBy' | 'isClosable'>
>) => {
  const [isScrolling, setIsScrolling] = React.useState(false)

  return (
    <SplitViewCardInternalContext.Provider
      value={{
        ariaLabelledBy,
        isClosable,
        isScrolling,
        setIsScrolling,
      }}
    >
      {children}
    </SplitViewCardInternalContext.Provider>
  )
}

export const useSplitViewCardInternal = () =>
  React.useContext(SplitViewCardInternalContext)
